export default __webpack_public_path__ + "fr/static/media/Logo_GIE-CB.e0bbe80a.svg";